const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/aiaibot.ts';
import { theme } from './clientSetupManager';

const aiAiBotStyle = `
    #aiaibot-mountpoint iframe[name=aiaibot-chat] {
        @media (max-width: ${theme?.breakpoints?.values?.sm}px) {
            bottom: 52px !important;
        }
        @media (min-width: ${theme?.breakpoints?.values?.sm}px) {
            bottom: 37px !important;
        }
        max-height: 90% !important;

    }
`;

const AIAIBOT_SRC = 'https://chat.aiaibot.com/bootstrap.js';

export const addAiAiBot = (aiaiBotApiKey: string | undefined) => {
    let script: HTMLScriptElement;
    if (aiaiBotApiKey !== undefined) {
        // Dynamically inject the AiaiBot script
        script = document.createElement('script');
        script.src = AIAIBOT_SRC;
        script.type = 'text/javascript';
        script.defer = true;
        script.setAttribute('data-aiaibot-key', aiaiBotApiKey);

        document.body.appendChild(script);

        // Dynamically inject the style for #aiaibot-chat
        const style: HTMLStyleElement = document.createElement('style');
        style.type = 'text/css';

        style.appendChild(document.createTextNode(aiAiBotStyle));

        document.head.appendChild(style);

        // Clean up both the script and style when the component unmounts
        return () => {
            if (script) {
                document.body.removeChild(script);
            }
            document.head.removeChild(style);
        };
    }
};
